import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        Sidebar_drawer: null,
        Customizer_drawer: false,
        SidebarColor: 'gold',
        SidebarBg: '',
        isLoggedIn: !!localStorage.getItem('isLoggedIn'),
      },
    mutations: {
        SET_SIDEBAR_DRAWER (state, payload) {
            state.Sidebar_drawer = payload
        },
        SET_CUSTOMIZER_DRAWER (state, payload) {
            state.Customizer_drawer = payload
        },
        SET_SIDEBAR_COLOR (state, payload) {
            state.SidebarColor = payload
        }, 

        loginUser(state) {
            state.isLoggedIn = true
            localStorage.setItem('isLoggedIn', true)
        },
        logoutUser(state) {
            state.isLoggedIn = false
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem("token");
            state.isLoggedIn = "";
        },
        sessionOut(state) {
            state.isLoggedIn = false
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem("token");
            state.isLoggedIn = "";
        }

    },
    actions: {

    }
})